import { createApp } from "vue";
import App from "./App.vue"; // root
import router from "./router"; // router
import { installUmengAnalytics } from "./assets/umeng";

// 在安装路由之前注册统计，首屏与后续路由统一上报，避免漏报或重复计数。
installUmengAnalytics(router);
const app = createApp(App).use(router);

// 仅在手动追加 ?vconsole=1 时异步加载，避免测试调试工具进入普通用户的首屏资源。
if (new URLSearchParams(window.location.search).get("vconsole") === "1") {
    import("vconsole").then(({ default: VConsole }) => {
        window.__wellceeVConsole = new VConsole();
        console.info("[LandlordHosting] vConsole 已启用");
    }).catch((error) => {
        console.error("[LandlordHosting] vConsole 加载失败", error);
    });
}

// util
import util from "./assets/util";
app.config.globalProperties.util = util;

// i18n
import { createI18n } from "vue-i18n";
import messages from "./i18n/messages";

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: util.language("text") || "zh", // set locale
    fallbackLocale: ["en", "tw"], // set fallback locale
    messages: messages, // set locale messages
});
app.use(i18n);

// download plugin
import download from "./assets/download";
app.use(download);

import hevueImgPreview from 'hevue-img-preview/v3'
app.use(hevueImgPreview, {
    arrowBtn: false,
    thumbnail: true,
    closeBtn: false,
    controlBar: ['rotateRight', 'download', 'prev', 'next'],
})

app.mount("#app");
